import { debounce, minWidthQuery, createSlider, getObserver, layoutRecalcManager } from '@theme/theme-global';
if (!customElements.get('featured-collection')) {
  class FeaturedCollection extends HTMLDivElement {
    constructor() {
      super();
      this.section = this.closest('.shopify-section');
      this.sliderInstance = null;
      this._observer = null;
      this.mediaQuery = minWidthQuery(768);
    }

    connectedCallback() {
      if (!this.sliderInstance) {
        this.init();
      }
    }

    disconnectedCallback() { }

    init() {
      const isFirstSection = this.section && this.section.querySelector('[data-index]').dataset.index === '1';
      const isMobile = window.matchMedia('(max-width: 767px)').matches;

      if (isFirstSection) {
        if (isMobile && typeof window.skyAfterLCP === 'function') {
          window.skyAfterLCP(() => {
            createSlider(this, JSON.parse(this.dataset.params)).then((instance) => {
              this.sliderInstance = instance;
            });
          });
        } else {
          createSlider(this, JSON.parse(this.dataset.params)).then((instance) => {
            this.sliderInstance = instance;
          });
        }
      } else if ('IntersectionObserver' in window) {
        this._observer = getObserver({ rootMargin: '300px 0px', threshold: 0 }, true, false);
        this._observer.observe(this, () => {
          const initFeaturedSlider = () => {
            if (this.sliderInstance || this._sliderInitializing) return;
            this._sliderInitializing = true;
            layoutRecalcManager.isMuted = true;
            createSlider(this, JSON.parse(this.dataset.params))
              .then((instance) => {
                this.sliderInstance = instance;
              })
              .finally(() => {
                this._sliderInitializing = false;
                setTimeout(() => {
                  layoutRecalcManager.isMuted = false;
                }, 100);
              });
          };

          const run = () => {
            if ('requestIdleCallback' in window) {
              requestIdleCallback(initFeaturedSlider);
            } else {
              requestAnimationFrame(() => {
                setTimeout(initFeaturedSlider, 0);
              });
            }
          };

          if (isMobile && typeof window.skyAfterLCP === 'function') {
            window.skyAfterLCP(run);
          } else {
            run();
          }
        });
      } else {
        createSlider(this, JSON.parse(this.dataset.params)).then((instance) => {
          this.sliderInstance = instance;
        });
      }
      this.classList.add('swiper-visible'); //class added for overflow visible
    }
  }

  customElements.define('featured-collection', FeaturedCollection, { extends: 'div' });
}
